var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

import Label from '../label';
import SelectorDropdown from '../selector-dropdown';
import parseCSV from '../../utils/parseCSV';
import { OptionsPropType } from '../../common/box-proptypes';

import PillSelector from './PillSelector';

import './PillSelectorDropdown.scss';

var PillSelectorDropdown = function (_Component) {
    _inherits(PillSelectorDropdown, _Component);

    function PillSelectorDropdown() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PillSelectorDropdown);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PillSelectorDropdown.__proto__ || Object.getPrototypeOf(PillSelectorDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = { inputValue: '' }, _this.parsePills = function () {
            var inputValue = _this.state.inputValue;
            var _this$props = _this.props,
                parseItems = _this$props.parseItems,
                validator = _this$props.validator;


            var pills = parseItems ? parseItems(inputValue) : parseCSV(inputValue);

            if (!pills) {
                return [];
            }

            if (validator) {
                pills = pills.filter(function (pill) {
                    return validator(pill);
                });
            }

            // Keep the data format consistent with DatalistItem
            return pills.map(function (pill) {
                return {
                    text: pill,
                    value: pill
                };
            });
        }, _this.addPillsFromInput = function () {
            var _this$props2 = _this.props,
                allowCustomPills = _this$props2.allowCustomPills,
                onInput = _this$props2.onInput,
                onSelect = _this$props2.onSelect,
                selectedOptions = _this$props2.selectedOptions,
                validateForError = _this$props2.validateForError;
            var inputValue = _this.state.inputValue;

            // Do nothing if custom pills are not allowed

            if (!allowCustomPills) {
                return;
            }

            // Parse pills from input
            var pills = _this.parsePills();

            // "Select" the pills
            if (pills.length > 0) {
                onSelect(pills);

                // Reset inputValue
                _this.setState({ inputValue: '' });
                onInput('');
            } else if (validateForError && (inputValue !== '' || selectedOptions.length === 0)) {
                /**
                 * If no pills were added, but an inputValue exists or
                 * there are no pills selected, check for errors
                 */
                validateForError(inputValue);
            }
        }, _this.handleBlur = function () {
            _this.addPillsFromInput();
        }, _this.handleInput = function (_ref2) {
            var target = _ref2.target;
            var value = target.value;

            _this.setState({ inputValue: value });
            _this.props.onInput(value);
        }, _this.handleEnter = function (event) {
            event.preventDefault();
            _this.addPillsFromInput();
        }, _this.handlePaste = function () {
            /**
             * NOTE (ishay): setTimeout is necessary because
             * otherwise addPillsFromInput gets triggered as soon
             * as the user "paste's", but before the inputValue
             * is actually updated.
             */
            setTimeout(_this.addPillsFromInput, 0);
        }, _this.handleSelect = function (index, event) {
            var _this$props3 = _this.props,
                onSelect = _this$props3.onSelect,
                selectorOptions = _this$props3.selectorOptions;

            var selectedOption = typeof selectorOptions.get === 'function' ? selectorOptions.get(index) : selectorOptions[index];

            onSelect([selectedOption], event);

            _this.handleInput({ target: { value: '' } });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PillSelectorDropdown, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className,
                disabled = _props.disabled,
                error = _props.error,
                inputProps = _props.inputProps,
                label = _props.label,
                onRemove = _props.onRemove,
                placeholder = _props.placeholder,
                selectedOptions = _props.selectedOptions;


            return React.createElement(
                SelectorDropdown,
                {
                    className: classNames('pill-selector-wrapper', className),
                    onEnter: this.handleEnter,
                    onSelect: this.handleSelect,
                    selector: React.createElement(
                        Label,
                        { text: label },
                        React.createElement(PillSelector, _extends({}, inputProps, {
                            disabled: disabled,
                            error: error,
                            onBlur: this.handleBlur,
                            onInput: this.handleInput,
                            onPaste: this.handlePaste,
                            onRemove: onRemove,
                            placeholder: placeholder,
                            selectedOptions: selectedOptions,
                            value: this.state.inputValue
                        }))
                    )
                },
                children
            );
        }
    }]);

    return PillSelectorDropdown;
}(Component);

PillSelectorDropdown.propTypes = {
    /** If true, user can add pills not included in selector options */
    allowCustomPills: PropTypes.bool,
    /** `DatalistItem` components for dropdown options to select */
    children: PropTypes.node,
    /** CSS class for the component */
    className: PropTypes.string,
    /** If true, the input control is disabled so no more input can be made */
    disabled: PropTypes.bool,
    /** Error message */
    error: PropTypes.node,
    /** Passed in by `SelectorDropdown` for accessibility */
    inputProps: PropTypes.object.isRequired,
    /** Input label */
    label: PropTypes.node,
    /** Should update selectorOptions based on the given input value */
    onInput: PropTypes.func.isRequired,
    /** Should update selectedOptions given the option and index to remove */
    onRemove: PropTypes.func.isRequired,
    /** Should update selectedOptions given an array of pills and the event */
    onSelect: PropTypes.func.isRequired,
    /** function to parse user input into an array of items to be validated and then added to pill selector. If this function is not passed, a default CSV parser is used. */
    parseItems: PropTypes.func,
    /** A placeholder to show in the input when there are no pills */
    placeholder: PropTypes.string.isRequired,
    /** Array or Immutable list with data for the selected options shown as pills */
    selectedOptions: OptionsPropType,
    /** Array or Immutable list with data for the dropdown options to select */
    selectorOptions: OptionsPropType,
    /** Validate the given input value, and update `error` prop if necessary */
    validateForError: PropTypes.func,
    /** Called to check if pill item data is valid. The `item` is passed in. */
    validator: PropTypes.func
};
PillSelectorDropdown.defaultProps = {
    allowCustomPills: false,
    disabled: false,
    error: '',
    inputProps: {},
    label: '',
    placeholder: '',
    selectedOptions: [],
    selectorOptions: []
};


export default PillSelectorDropdown;